import { render, staticRenderFns } from "./UserPassword.vue?vue&type=template&id=34cee8ee"
import script from "./UserPassword.vue?vue&type=script&lang=js"
export * from "./UserPassword.vue?vue&type=script&lang=js"
import style0 from "./UserPassword.vue?vue&type=style&index=0&id=34cee8ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports